import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import MyAccountNav from '../components/MyAccountNav';
import EditAccountForm from "../features/customer/EditAccountForm";
import { selectToken } from "../features/user/userSlice";
import MyAccountPage from "./MyAccountPage";
import { useEffect } from "react";
import MenuButton from "../app/styles/components/MenuButton";
import Window from '../utils/Window';
import { selectIsMobileRoute } from "../features/mobile/mobileSlice";
import { useLocation } from 'react-router-dom';

export default function EditAccountPage() {
  const location = useLocation();
  const token = useSelector(selectToken);
  const AppURL = useSelector(selectIsMobileRoute);
  const urlParams = AppURL ? `/?${AppURL}` : '';
  const isAccountPage = location.state && location.state.isAccountPage === true;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  if (!token) {
    return (
      <MyAccountPage />
    )
  }

  return (
    <Container fluid="lg" className='edit-account-page'>
      <Row>
        {Window.isMobile() ?
          <>
            <Col xs={2} className='p-0 px-2 pt-2'>
              <MenuButton {...(
                !isAccountPage
                  ? { redirectURL: `/my-account/settings${urlParams}` }
                  : {}
              )} />
            </Col>
            <Col xs={10} className='p-0 px-3 d-flex align-items-center justify-content-end'>
              <span className="text-uppercase fw-400 fs-32px font-league-gothic">EDIT ACCOUNT</span>
            </Col>
          </> :
          <Col sm={12} md={3}>
            <MyAccountNav />
          </Col>}
        <Col sm={12} md={9} className={`${Window.isMobile() ? 'my-2' : 'my-5'}`}>
          <EditAccountForm />
        </Col>
      </Row>
    </Container>
  )
}